module.exports = __webpack_public_path__ + "img/goods_check.1f5fbf9b.svg";